import React, { useEffect, useState } from 'react'
import Container from '../../../components/Container';
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import DataFetching from "../../../helper/DataFetching";
import renderDataTable from "../../../helper/renderDataTable";
import Loading from "../../../components/Loading";
import { AddButton, ButtonDelete, ButtonEdit, formatMoment } from '../../../helper/CommonFunction';
import EditBudget from './EditBudget';
import Breadcrumb from '../../../components/Breadcrumb';
import AddBudget from './AddBudget';
import { toast } from 'react-toastify';
import { ApiHandler } from '../../../helper/ApiHandler';
import { ModalSmall } from '../../../components/ModalComponets';

const Budget = () => {
    const location = useLocation();
    const token = useSelector((state) => state.user.userToken)
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [filteredData, setFilteredData] = useState([]);
    const [pending, setPending] = useState(true);
    const [resetSearch, setResetSearch] = useState(true);
    const [editId, setEditId] = useState(null);
    const [editModal, setEditModal] = useState(false);
    const [addId, setAddId] = useState(null);
    const [addModal, setAddModal] = useState(false);
    const [deleteId, setdeleteId] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);

    const fetchData = async () => {
        setPending(true);
        await DataFetching(setPending, '/get_bike_budget.php', 'POST', token, dispatch, navigate, setFilteredData, undefined, setResetSearch, resetSearch);
    };

    // Render the DataTable component
    useEffect(() => {
        if (!resetSearch) {
            return;
        }
        fetchData();
    }, [location, resetSearch]);


    const openEditModal = row => {
        setEditId(row);
        setEditModal(true);
    };

    const openAddModal = row => {
        setAddId(row);
        setAddModal(true);
    };

    const DeleteUserModal = (row) => {
        setdeleteId(row);
        setDeleteModal(true);
    };

    const column = [
        {
            name: 'Price Ranges ID',
            selector: row => row.id,
            sortable: true,
            width: '20%'
        },
        {
            name: 'Start Price',
            selector: row => row.start_amount,
        },
        {
            name: 'End Price',
            selector: row => row.end_amount,
        },
        {
            name: "Actions",
            cell: (row) => (
                <div>
                    <ButtonEdit onclick={() => openEditModal(row)} />
                    <ButtonDelete onclick={() => DeleteUserModal(row)} />
                </div>
            ),
            width: '12%'
        },
    ]

    const DeleteUser = async () => {
        const body = {
            budget_id: deleteId.id,
        }

        try {
            const result = await ApiHandler('/delete_bike_budget.php', 'POST', body, token, dispatch, navigate)
            if (result?.data.status === "1") {
                toast.success(result?.data.msg)
                setDeleteModal(false)
                setdeleteId(null);
                setResetSearch((prevReset) => !prevReset);
            } else {
                toast.error(result?.data.msg)
            }
        } catch (error) {
            setDeleteModal(false)
        }
    };

    return (
        <>
            <Breadcrumb pageName="Saved Price Ranges" />
            <Container>
                <>
                    <AddButton text="Add Price Range" onClick={openAddModal} />
                    <div className="border-2 border-solid border-[#ddddddbe] w-full">
                        <div className='p-3 w-full'>
                            <div className='py-3'>
                                {renderDataTable(
                                    filteredData,
                                    column,
                                    pending
                                )}
                            </div>
                        </div>
                    </div>
                </>
            </Container>

            {editModal && editId && (
                <EditBudget
                    isOpen={editModal}
                    onClose={() => setEditModal(false)}
                    showData={editId}
                    setResetSearch={setResetSearch}
                    title="Edit Price Range"
                />
            )}

            {addModal && addId && (
                <AddBudget
                    isOpen={addModal}
                    onClose={() => setAddModal(false)}
                    setResetSearch={setResetSearch}
                    title="Add Price Range"
                />
            )}

            {
                deleteId && deleteModal && (
                    <ModalSmall
                        isOpen={deleteModal}
                        onClose={() => setDeleteModal(false)}
                        onConfirm={DeleteUser}
                    >
                        <div>
                            <h2 className="text-xl font-bold text-gray-800 mb-1">Confirm!</h2>
                            <p className="text-sm text-gray-600 mb-4">
                                Are you sure you want to Delete this Price Ranges?
                            </p>
                        </div>
                    </ModalSmall>
                )
            }
        </>
    )
}

export default Budget;